import { MapModalInterface } from '@modules/components-common';
import { SelectorCategory } from './selector-category.enum';
import { TicketSelectorFieldMap } from './ticket-selector-field-map';

export type TicketSelectorInfoModalMap = Record<
  SelectorCategory,
  TicketSelectorFieldMap<string>
>;

export type TicketSelectorMapInfoModelMap = Record<string, MapModalInterface>;
